// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__14de7","label":"Category_label__3V_3I","content":"Category_content__2uJeN","header":"Category_header__2UfSF","location":"Category_location__-Baw9"};